import { Modal } from 'antd'
import { BeatLoader } from 'react-spinners'

import { BLUE_COLOR, ORANGE_COLOR } from '@/constants'
import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './Loader.module.scss'

type LoaderPropsType = {
  isModalOpen?: boolean
  loaderType?: 'common' | 'modal'
  paddingTop?: number
  size?: number
  inTable?: boolean
}

function Loader(props: LoaderPropsType) {
  const {
    isModalOpen,
    loaderType = 'common',
    paddingTop,
    size = 15,
    inTable,
  } = props

  const { selectedOrganisation } = useUserInfoStore((state) => state)

  // Проверка безопасности: существует ли объект и есть ли в нем ключи
  const isOrgSelected = !!(
    selectedOrganisation && Object.keys(selectedOrganisation).length > 0
  )

  const spinnerColor = isOrgSelected ? BLUE_COLOR : ORANGE_COLOR

  return (
    <>
      {loaderType === 'modal' ? (
        <Modal
          maskProps={{
            style: {
              backdropFilter: 'blur(8px)',
              backgroundColor: 'transparent',
            },
          }}
          open={isModalOpen}
          className={cn.modal}
          closable={false}
          centered
          width="auto"
          transitionName=""
        >
          <BeatLoader color={spinnerColor} size={20} />
        </Modal>
      ) : (
        <div
          className={
            paddingTop
              ? [cn.loaderContainer, cn[`pt${paddingTop}`]].join(' ')
              : inTable
                ? [cn.loaderContainer, cn.inTable].join(' ')
                : cn.loaderContainer
          }
        >
          <BeatLoader color={spinnerColor} size={size} />
        </div>
      )}
    </>
  )
}

export default Loader
